;(() => {
  const mobileMenuToggle = document.querySelector('button#mobile-menu-toggle')
  mobileMenuToggle.addEventListener('click', function () {
    document.querySelector('#mobile-menu').classList.toggle('open')
    document.getElementsByTagName('HTML')[0].classList.add('overflow-hidden')
  })

  document
    .querySelectorAll('#close-mobile-menu, #mobile-menu-background')
    .forEach((element) => {
      element.addEventListener('click', () => {
        mobileMenuToggle.click()
        document
          .getElementsByTagName('HTML')[0]
          .classList.remove('overflow-hidden')
      })
    })

  document
    .querySelectorAll('#mobile-menu button.dropdown-toggle')
    .forEach((dropdown) => {
      dropdown.addEventListener('click', () => {
        dropdown.classList.toggle('active')
        const panel = dropdown.closest('header').nextElementSibling

        if (panel.style.maxHeight) {
          panel.style.maxHeight = null
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'

          // Recursively expand all parent accordions
          let parent = panel.parentElement.closest('.dropdown')
          while (parent) {
            parent.style.maxHeight =
              parent.scrollHeight + panel.scrollHeight + 'px'
            parent = parent.parentElement.closest('.dropdown')
          }
        }
      })
    })
})()
